import React from "react"

import { MultiPhoneNumberSelector } from "@/components/shared/forms/MultiPhoneNumberSelector"
import { SimulatorType } from "@/types/api/SimulatorType"
import type { VoicePersonaConfig } from "@/types/ModelConfigs/VoiceModelConfigs"

interface MultiPhoneConfigProps {
  modelType: SimulatorType
  metadata: VoicePersonaConfig
  onMetadataChange: (metadata: VoicePersonaConfig) => void
  disabled?: boolean
  showIcon?: boolean
}

export const MultiPhoneConfig: React.FC<MultiPhoneConfigProps> = ({
  modelType,
  metadata,
  onMetadataChange,
  disabled = false,
  showIcon = true,
}) => {
  if (modelType !== SimulatorType.VOICE) {
    return null
  }

  const currentPhoneIndex = metadata.multi_phone_config?.phone_number_index ?? 0

  const handlePhoneNumberIndexChange = (index: number) => {
    const updatedMetadata = {
      ...metadata,
      multi_phone_config: {
        ...metadata.multi_phone_config,
        phone_number_index: index,
      },
    }

    onMetadataChange(updatedMetadata)
  }

  return (
    <MultiPhoneNumberSelector
      selectedIndex={currentPhoneIndex}
      onSelect={handlePhoneNumberIndexChange}
      disabled={disabled}
      showIcon={showIcon}
    />
  )
}
